// WeDeV custom script for Sin Slider
// 
// Automatically initializes all swipers with class 'wd-sin-slider__swiper' on page load.
// Supports Shopify theme editor updates via shopify:section:load and shopify:section:reorder events.
// 
// Usage Options:
// 
// 1. Automatic initialization (default):
//    All elements with class 'wd-sin-slider__swiper' will be automatically initialized.
//    Navigation buttons should have classes 'wd-sin-slider__nav--prev' and 'wd-sin-slider__nav--next'.
// 
// 2. Custom selector via data attribute:
//    Add data-swiper-selector=".your-custom-selector" to the swiper element.
//    Example: <div class="wd-sin-slider__swiper" data-swiper-selector=".my-custom-swiper">
// 
// 3. Custom selectors via window variable (before DOMContentLoaded):
//    Set window.wdSinSliderSelectors = ['.selector1', '.selector2'] before this script loads.
//    Example:
//    <script>
//      window.wdSinSliderSelectors = ['.my-custom-swiper', '#another-swiper'];
//    </script>
//    <script src="{{ 'wd-sin-slider.js' | asset_url }}" defer="defer"></script>

(function () {
    if (typeof Swiper === 'undefined') return;

    // Store initialized swiper instances
    const swiperInstances = new WeakMap();

    // Function to destroy existing swiper if it exists
    const destroySwiper = (swiperEl) => {
        if (swiperInstances.has(swiperEl)) {
            const swiperInstance = swiperInstances.get(swiperEl);
            if (swiperInstance && typeof swiperInstance.destroy === 'function') {
                swiperInstance.destroy(true, true);
            }
            swiperInstances.delete(swiperEl);
        }
    };

    // Function to initialize a single swiper
    const initSwiper = (swiperEl) => {
        // Destroy existing swiper if it exists
        destroySwiper(swiperEl);

        const prevBtn = swiperEl.querySelector('.wd-sin-slider__nav--prev');
        const nextBtn = swiperEl.querySelector('.wd-sin-slider__nav--next');
        const customSelector = swiperEl.getAttribute('data-swiper-selector');

        // Use custom selector if provided, otherwise use the element itself
        const swiperTarget = customSelector ? document.querySelector(customSelector) : swiperEl;

        if (!swiperTarget) return;

        let marginDesktop = 20, marginMobile = 18;

        // Check if slides meet requirements for loop mode to work correctly
        // For slidesPerView: "auto" with loop, Swiper needs enough slides to duplicate
        // The total width should be at least 2x the container width for seamless looping
        const wrapper = swiperTarget.querySelector('.swiper-wrapper');
        const slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : [];
        const containerWidth = swiperTarget.offsetWidth;

        // Need at least 3 slides for loop to work properly (Swiper requirement)
        let shouldLoop = false;
        let loopedSlidesCount = 0;

        if (slides.length >= 3) {
            // Calculate total slides width
            let totalSlidesWidth = 0;
            slides.forEach((slide) => {
                const rect = slide.getBoundingClientRect();
                totalSlidesWidth += rect.width;
            });

            // Add space between slides
            const spaceBetween = window.innerWidth >= 769 ? marginMobile : marginDesktop;
            const totalWidth = totalSlidesWidth + (spaceBetween * (slides.length - 1));

            // For loop mode with slidesPerView: "auto", Swiper needs enough content to duplicate
            // The total width should be at least 1.6x the container width to allow proper duplication
            // This ensures Swiper can create seamless loop without glitches
            const minRequiredWidth = containerWidth * 1.5;
            shouldLoop = totalWidth >= minRequiredWidth;

            // Set loopedSlides - Swiper recommends at least 2 slides for duplication
            // Using a percentage of total slides (around 30-40%) works well for smooth looping
            if (shouldLoop) {
                loopedSlidesCount = Math.max(2, Math.min(Math.ceil(slides.length * 0.4), Math.floor(slides.length / 2)));
            }
        }

        const swiperConfig = {
            slidesPerGroup: 1,
            slidesPerView: "auto",
            centeredSlides: true,

            loop: shouldLoop,
            loopAddBlankSlides: shouldLoop,

            speed: 600,
            spaceBetween: marginMobile,
            initialSlide: ~~(slides.length / 2),
            navigation: prevBtn && nextBtn ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
            } : false,
            breakpoints: {
                769: { spaceBetween: marginDesktop },
            },
        };

        // Add loopedSlides only if loop is enabled
        if (shouldLoop && loopedSlidesCount > 0) {
            swiperConfig.loopedSlides = loopedSlidesCount;
        }

        const swiperInstance = new Swiper(swiperTarget, swiperConfig);

        // Store the swiper instance
        swiperInstances.set(swiperEl, swiperInstance);
    };

    // Function to initialize all sliders in a container
    const initializeSliders = (container = document) => {
        const sliders = container.querySelectorAll('.wd-sin-slider__swiper');
        sliders.forEach(initSwiper);

        // Also support custom selector via window variable
        if (window.wdSinSliderSelectors && Array.isArray(window.wdSinSliderSelectors)) {
            window.wdSinSliderSelectors.forEach((selector) => {
                const customSliders = container.querySelectorAll(selector);
                customSliders.forEach(initSwiper);
            });
        }
    };

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initializeSliders();
        });
    } else {
        initializeSliders();
    }

    // Handle window resize - re-initialize sliders to recalculate loop
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initializeSliders();
        }, 150);
    });

    // Handle Shopify theme editor updates
    if (window.Shopify && window.Shopify.designMode) {
        // Re-initialize when a section is loaded/updated
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target) {
                initializeSliders(event.target);
            }
        });

        // Re-initialize when sections are reordered
        document.addEventListener('shopify:section:reorder', () => {
            initializeSliders();
        });
    }
})();
